// extracted by mini-css-extract-plugin
export var teachers = "teachers-module--teachers--3AO-y";
export var teacher = "teachers-module--teacher--Da8u6";
export var teacherName = "teachers-module--teacherName--u-6jF";
export var imageWrapper = "teachers-module--imageWrapper--f6jNX";
export var description = "teachers-module--description--NfnRi";
export var image = "teachers-module--image--F-76w";